import { type IDataStoreRecordBehaviors } from '../collaboration/DataStoreRecordBehaviors';
import type WhiteboardController from '../controllers/WhiteboardController';
import type CanvaSXBehaviors from './CanvaSXBehaviors';

export type FieldObjectType = IDataStoreRecordBehaviors &
  CanvaSXBehaviors &
  fabric.Object;

class ObjectValue {
  static shouldRender(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    object: FieldObjectType,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    controller: WhiteboardController
  ): boolean {
    return false;
  }

  static renderFields(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    maxChildWidth: number,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    object: FieldObjectType,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    controller: WhiteboardController
  ): CanvaSXNode[] {
    return [];
  }
}

export default ObjectValue;
